import { push, ref, remove, set, update } from "firebase/database";
import { message } from "antd";
import { database } from "../../configs";
import { getUserId, trackEvent } from "../../helpers";

export default class Products {
  async create(params) {
    const {
      establishmentID,
      data,
      formatMessage,
      skipMessage = false,
    } = params;

    try {
      const userID = await getUserId();
      const productsRef = ref(
        database,
        `${userID}/Establishments/${establishmentID}/Products`,
      );
      const newProductRef = push(productsRef);

      await set(newProductRef, {
        id: newProductRef.key,
        ...data,
      });

      if (!skipMessage) {
        trackEvent("product_created", {
          establishment_id: establishmentID,
          product_id: newProductRef.key,
        });
        message.success(formatMessage({ id: "admin.menu.product.created" }));
      }

      return newProductRef.key;
    } catch (error) {
      if (!skipMessage) {
        message.error(formatMessage({ id: "admin.menu.product.create.error" }));
      }
      return null;
    }
  }

  async update(establishmentID, ProductID, fieldParams, formatMessage) {
    try {
      const userID = await getUserId();
      const updateListRef = ref(
        database,
        `${userID}/Establishments/${establishmentID}/Products/${ProductID}`,
      );

      await update(updateListRef, fieldParams);

      message.success(formatMessage({ id: "admin.menu.product.updated" }));
    } catch (error) {
      message.error(formatMessage({ id: "admin.menu.product.update.error" }));
    }
  }

  async delete(establishmentID, ProductID, hasSingleDelete, formatMessage) {
    try {
      const userID = await getUserId();
      const deleteListRef = ref(
        database,
        `${userID}/Establishments/${establishmentID}/Products/${ProductID}`,
      );

      await remove(deleteListRef);

      if (hasSingleDelete) {
        trackEvent("product_deleted", {
          establishment_id: establishmentID,
          product_id: ProductID,
        });
        message.success(formatMessage({ id: "admin.menu.product.deleted" }));
      }
    } catch (error) {
      if (hasSingleDelete) {
        message.error(formatMessage({ id: "admin.menu.product.delete.error" }));
      }
    }
  }

  async activateDeactivate(
    establishmentID,
    ProductID,
    activateDeactivateParams,
    formatMessage,
  ) {
    try {
      const userID = await getUserId();
      const activateDeactivateListRef = ref(
        database,
        `${userID}/Establishments/${establishmentID}/Products/${ProductID}`,
      );

      await update(activateDeactivateListRef, activateDeactivateParams);

      message.success(formatMessage({ id: "admin.menu.product.updated" }));
    } catch (error) {
      message.error(formatMessage({ id: "admin.menu.product.update.error" }));
    }
  }

  async reorder(establishmentID, updatedItems, formatMessage) {
    try {
      const userID = await getUserId();
      const createListRef = ref(
        database,
        `${userID}/Establishments/${establishmentID}/Products`,
      );

      await update(createListRef, updatedItems);

      message.success(formatMessage({ id: "admin.menu.product.reordered" }));
    } catch (error) {
      message.error(formatMessage({ id: "admin.menu.product.reorder.error" }));
    }
  }
}
